<app-browse-section-list [scope]="data.scope" [folder]="data"></app-browse-section-list>
